  <div class="iframe-container" style="flex-grow: 1; width: 100vw; height:100vh; border: none; margin: 0; padding: 0;">
    <iframe src="https://yaarilab.github.io/macaques_refrence_book/" title="Macaques Reference Book"></iframe>
  </div>
